// NOTE:: THIS IS A SERVERMIDDLEWARE NOT A CLIENT MIDDLEWARE
// https://nuxtjs.org/docs/configuration-glossary/configuration-servermiddleware/
export default function (_, res, next) {
  res.setHeader('Content-Security-Policy', "frame-ancestors 'none'")
  res.setHeader('Cache-Control', 'no-cache')

  next()
}
